import { render, staticRenderFns } from "./PageGoodsPublish.vue?vue&type=template&id=0ff4e56f&scoped=true"
import script from "./PageGoodsPublish.vue?vue&type=script&lang=js"
export * from "./PageGoodsPublish.vue?vue&type=script&lang=js"
import style0 from "./PageGoodsPublish.vue?vue&type=style&index=0&id=0ff4e56f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff4e56f",
  null
  
)

export default component.exports